<ng-container *ngIf="person[0] as currentPerson">
  <nav class="subnav">
    <ul class="nav">
      <li class="nav-item">
        <a class="nav-link active" [routerLink]="['/person/details/', currentPerson.pid]">Zurück zur Person</a>
      </li>
    </ul>
  </nav>

  <main>
    <h2>PHM PPS  <cds-icon shape="two-way-arrows"></cds-icon>  Person bearbeiten  <cds-icon shape="two-way-arrows"></cds-icon>  {{ currentPerson.pid }}</h2>
      <app-person-form [personForm]="personForm"></app-person-form><br>
      <button class="btn btn-danger-outline btn-small" type="submit" [disabled]="personForm.invalid" (click)="onSubmit()">Speichern</button>
      <a class="btn btn-info-outline btn-small" [routerLink]="['/person/details/', currentPerson.pid]">Abbrechen</a>
  </main>
</ng-container>
